import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// import About from './About';
import styles from './aboutOur.module.css';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const SearchTab = (props) => {

    const {searchFor, setSearchFor} = props;
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {

        setValue(newValue);

        if(newValue == 0){
            setSearchFor("courses");
        } else if(newValue == 1){
            setSearchFor("diploma");
        } else if(newValue == 2){
            setSearchFor("certificate");
        }
    };

    useEffect(() => {        
        if(searchFor == "courses"){
            setValue(0);
        } else if(searchFor == "diploma"){
            setValue(1);
        } else if(searchFor == "certificate"){
            setValue(2);
        }
      }, [searchFor]);


    return (
        <>
            <div className={styles.aboutOurMainContainer}>
                <div className={styles.aboutOurContainer}>
                    <div>
                        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" indicatorColor={false}>
                                    <Tab label="Courses" {...a11yProps(0)} />
                                    <Tab label="Diploma" {...a11yProps(1)} />
                                    <Tab label="Certificates" {...a11yProps(2)} />
                                </Tabs>
                            </Box>
                            {/* <CustomTabPanel value={value} index={0}>
                                <About />
                            </CustomTabPanel> */}
                            {/* <CustomTabPanel value={value} index={1}>
                                <About />
                            </CustomTabPanel> */}
                            {/* <CustomTabPanel value={value} index={2}>
                                <About />
                            </CustomTabPanel> */}
                        </Box>

                    </div>
                </div>
            </div>
        </>
    );
};

export default SearchTab;
